import { enumNumericValues } from '@sonar-software/sonar-ts-lib';
import { FieldUsageId } from '@sonar-software/sonar-core';
import { OptionFilter } from '@periscopes/general/filters';

import { COPY_GENERIC, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React, { memo } from 'react';

const options = enumNumericValues(FieldUsageId)
	.map((value) => ({
		label: FieldUsageId[ value ],
		value
	}));

export interface FieldUsageBulkSelectorProps {
	onChange: (value: unknown) => void;
	value?: number;
}

export const FieldUsageBulkSelector: React.FC<FieldUsageBulkSelectorProps> = memo(({ onChange, value }) =>
	<OptionFilter
		onChange={ (id) => onChange(id) }
		options={ options }
		placeholder={ COPY_GENERIC.SELECT(COPY_SPECIFIC.FIELD_USAGE) }
		value={ value } />);
